import angular from 'angular'
import checkStreamsCtrl from './checkStreamsCtrl'
import chooseCheckPersonCtrl from './chooseCheckPersonCtrl'


import {
    checkStreams
} from 'redevConfig'


const setting = (checkStreams && checkStreams.setting) || ''
const branchAdd = (checkStreams && checkStreams.branchAdd) || ''
const list = (checkStreams && checkStreams.list) || ''

const checkStreamsListCtrl = list ? require(`redevelopment/system/checkStreams/${list.controllerName}`) : require('./checkStreamsListCtrl')
const checkStreamsSettingCtrl = setting ? require(`redevelopment/system/checkStreams/${setting.controllerName}`) : require('./checkStreamsSettingCtrl')
const checkStreamsBranchEditCtrl = branchAdd ? require(`redevelopment/system/checkStreams/${branchAdd.controllerName}`) : require('./checkStreamsBranchEditCtrl')

const listPage = list ? require(`redevelopment/system/checkStreams/${list.templateName}`) : require('./views/checkStreamslist.html')
const settingPage = setting ? require(`redevelopment/system/checkStreams/${setting.templateName}`) : require('./views/checkStreamssetting.html')
const editPage = branchAdd ? require(`redevelopment/system/checkStreams/${branchAdd.templateName}`) : require('./views/checkStreamsBranchEdit.html')


export default angular
    .module('system.settingcenter.checkStreams', [])
    .config(['$stateProvider', function config ($stateProvider) {
        $stateProvider
            .state('system.settingcenter.checkStreams', {
                abstract: true,
                url: '/checkStreams',
                template: '<div ui-view></div>',
                // controller: 'checkStreamsCtrl',
                title: '审批设置',
                default: 'system.settingcenter.checkStreams.list',
            })
            .state('system.settingcenter.checkStreams.list', {
                url: '/list',
                template: listPage,
                controller: 'checkStreamsListCtrl',
            })
            .state('system.settingcenter.checkStreams.setting', {
                url: '/setting/:id',
                template: settingPage,
                controller: 'checkStreamsSettingCtrl',
                title: '设置审批流程',
            })
            .state('system.settingcenter.checkStreams.branchAdd', {
                url: '/branchAdd/:approveCode',
                template: editPage,
                controller: 'checkStreamsBranchEditCtrl',
                title: '设置判断条件',
            })
            .state('system.settingcenter.checkStreams.branchEdit', {
                url: '/branchAdd/:approveCode/:branchId',
                template: editPage,
                controller: 'checkStreamsBranchEditCtrl',
                title: '设置判断条件',
            })
    }])
    .controller('checkStreamsCtrl', checkStreamsCtrl)
    .controller('checkStreamsListCtrl', checkStreamsListCtrl.default)
    .controller('checkStreamsSettingCtrl', checkStreamsSettingCtrl.default)
    .controller('chooseCheckPersonCtrl', chooseCheckPersonCtrl)
    .controller('checkStreamsBranchEditCtrl', checkStreamsBranchEditCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/checkStreams/index.js